module.exports = __webpack_public_path__ + "img/resume-parser.ca46934f.svg";